import { useEffect, useRef, useState } from "react";

const CustomDropdown = ({ label = "Select", options = [], value, onChange, extra }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = () => {
    if (!value) return label;
    const found = options.find((opt) =>
      typeof opt === "object" ? opt.value === value : opt === value
    );
    return found ? (typeof found === "object" ? found.label : found) : label;
  };

  const handleOptionClick = (option) => {
    const selectedValue = typeof option === "object" ? option.value : option;
    onChange?.(selectedValue); // ✅ corrected from onClick to onChange
    setOpen(false);
  };

  return (
    <div className={`relative inline-block min-w-[200px] ${extra}`} ref={dropdownRef}>
      <button
        type="button"
        onClick={toggleDropdown}
        className="w-full px-4 py-2 text-left bg-white border rounded-md shadow-sm hover:bg-gray-100 dark:bg-navy-800 dark:text-white dark:hover:bg-gray-600 dark:!border-white/10"
      >
        {selectedLabel()}
        <svg
          className={`w-5 h-5 float-right transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto dark:!border-white/10">
          {options.map((option, index) => {
            const display = typeof option === "object" ? option.label : option;
            const val = typeof option === "object" ? option.value : option;
            const isSelected = val === value;
            return (
              <button
                key={index}
                type="button"
                onClick={() => handleOptionClick(option)}
                className={`w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-600 ${
                  isSelected ? "bg-gray-200 font-semibold dark:bg-navy-700" : "bg-white dark:bg-navy-800"
                }`}
              >
                {display}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
